import { create } from 'zustand'
import { SPACE_TABS, SpaceTabType } from '@/constants/spaces.constants'

/**
 * Store for Spaces section that manages shared UI state
 * Only contains state that needs to be accessed across components
 */
interface SpacesStore {
  // Active tab
  activeTab: SpaceTabType
  // Search term
  searchTerm: string
  // Loading states
  conversationsLoading: boolean
  reportsLoading: boolean

  // Actions
  setActiveTab: (tab: SpaceTabType) => void
  setSearchTerm: (term: string) => void
  setConversationsLoading: (loading: boolean) => void
  setReportsLoading: (loading: boolean) => void
}

export const useSpacesStore = create<SpacesStore>((set) => ({
  // Initial state
  activeTab: SPACE_TABS.CONVERSATIONS,
  searchTerm: '',
  conversationsLoading: false,
  reportsLoading: false,

  // Actions
  setActiveTab: (tab) => set({ activeTab: tab }),
  setSearchTerm: (term) => set({ searchTerm: term }),
  setConversationsLoading: (loading) => set({ conversationsLoading: loading }),
  setReportsLoading: (loading) => set({ reportsLoading: loading }),
}))
